<div class="chat-bubble-container">
  <img src="assets/images/{{environment.chatLogo}}" alt="Thumbnail" class="chat-thumbnail" >
  <div class="chat-bubble">

    <markdown
      [innerHTML]="processedText"
      class="p-3 mb-3"
      (click)="onGuidClick($event)">
    </markdown>
    <i (click)="openUploadDialog(VOTE_OPTION.THUMBS_UP,this.message.messageId)" class="bi bi-hand-thumbs-up-fill mr-2 " style="cursor:pointer;" data-bs-toggle="tooltip" data-bs-placement="top" title="{{'chat.thumbsUp' | translate }}"></i>
    <i (click)="openUploadDialog(VOTE_OPTION.THUMBS_DOWN,this.message.messageId)"  class="bi bi-hand-thumbs-down-fill mr-1" style="cursor:pointer;"  data-bs-toggle="tooltip" data-bs-placement="top" title="{{'chat.thumbsDown' | translate }}"></i>

  </div>
</div>
